import PriceComponent from './PriceComponent';

export default PriceComponent;
